import { toast } from 'react-toastify';

export const ToastsErrorBottomLeft = (messages: string[]) => {
  messages.forEach((message) => {
    if (!toast.isActive(message)) {
      toast.error(message, {
        position: toast.POSITION.TOP_LEFT,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        autoClose: 10000,
        toastId: message,
      });
    }
  });
};

export const ToastsWarningTopLeft = (messages: string[]) => {
  messages.forEach((message) => {
    if (!toast.isActive(message)) {
      toast.warning(message, {
        position: toast.POSITION.TOP_LEFT,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        autoClose: 10000,
        toastId: message,
      });
    }
  });
};

export const ClearAllToasts = () => {
  toast.dismiss();
};

export const ClearToastByMessage = (message: string) => {
  toast.dismiss(message);
};
